import React from 'react';
import { string } from 'prop-types';
import { connect } from 'react-redux';
import SliderHeaderv3 from 'Shared/SliderHeader/V3';
import Slide from '../Slide';

import { getCategorySelected } from '../FiltersV2/redux/selectors';

class SliderHeaderV2 extends React.Component {
  getBanners = () => {
    const { banners, categoriesBanners, categorySelected } = this.props;

    if (categorySelected) {
      const categoryBanners = categoriesBanners[categorySelected.slug];

      if (categoryBanners && categoryBanners.length > 0) {
        return categoriesBanners[categorySelected.slug];
      }

      return banners;
    }

    return banners;
  };

  renderSlide = (props, i) => (
    <div key={i} style={{ borderRadius: 10 }}>
      <Slide
        {...props}
        subtitle={props.sub_title}
        img={props.banner_image}
        titleColor={props.title_color}
        subtitleColor={props.sub_title_color}
      />
    </div>
  );

  render() {
    const bannersToRender = this.getBanners();

    if (bannersToRender.length === 0) return null;

    return (
      <SliderHeaderv3>{bannersToRender.map(this.renderSlide)}</SliderHeaderv3>
    );
  }
}

SliderHeaderV2.defaultProps = {
  headerWrapperStyles: '',
};
SliderHeaderV2.propTypes = {
  headerWrapperStyles: string,
};

export default connect(state => ({
  banners: state.banners,
  categoriesBanners: state.categoriesBanners,
  categorySelected: getCategorySelected(state).categorySelected,
}))(SliderHeaderV2);
